import { CircularProgress, styled } from "@mui/material";

export const StyledLoader = styled(CircularProgress)`
  color: ${(props) => props.theme.wsc.palette.neutral[0]};
`;
